import { Checkbox } from "@mui/material";
import { getIn, useField, useFormikContext } from "formik";
import { useEffect } from "react";
import { StyledFormikCheckbox } from "../../styled/FormikCheckbox";

const FormikCheckbox = (props) => {
  const [field] = useField(props);
  const { values } = useFormikContext();
  const fieldValue = getIn(values, props.name);

  useEffect(() => {
    if (props.callBack) {
      props.callBack(fieldValue);
    }
  }, [fieldValue]);

  return (
    <StyledFormikCheckbox.Checkbox
      control={
        <Checkbox
          name={props.name}
          {...field}
          checked={field.value}
          {...props}
        />
      }
      {...props}
    />
  );
};

export default FormikCheckbox;
